var appHeaderI18n = {
  toggle: 'Toggle Menu'
};
export default appHeaderI18n;